export default {
  banner: ['Banco de', 'Talentos'],
  title: 'Cadastre-se em nosso banco de talentos',
}
